import {
    SELECTED_PATIENT, CLEAR_PATIENT
} from '../actions/types';


const selectedPatientReducer = (selectedPatient = {}, action) => {
    if (action.type === SELECTED_PATIENT) {
        return action.payload;
    } else if (action.type === CLEAR_PATIENT) {
        return {};
    }

    return selectedPatient;
};

export default selectedPatientReducer;